import InputWrapper from "./input-wrapper";
export interface SubmitProps {
  name?: string;
  loading: boolean;
}
const Submit = ({ name, loading }: SubmitProps) => {
  return (
    <InputWrapper label="">
      <button className="signup-btn p-5 flex" type="submit">
        {loading ? "درحال ارسال" : name || "ثبت"}
        <span className="sepanta-icon-left-long-arrow"></span>
      </button>
    </InputWrapper>
  );
};

export default Submit;
